<template>
  <div class="item-container" v-if="layerProduct.product">
    <div class="item-image" :style="backgroundImage"></div>

    <div class="item-text-wrapper">
      <div class="item-name">{{ layerProduct.product.brand_name }}</div>

      <div class="actions">
        <i
          class="action-icon pe-7s-link"
          v-bind:class="{ active: layerProduct.custom_url }"
          @click="showAddReferralLinkModal()"
        ></i>

        <a
          :href="layerProduct.external_url"
          alt="Product link"
          target="_blank"
          rel="noopener noreferrer"
          class="action-link"
        >
          <i class="action-icon pe-7s-look"></i>
        </a>

        <i
          class="action-icon pe-7s-trash"
          @click="showRemoveProductModal()"
          v-if="!capsulePublished"
        ></i>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { bus } from "@/main";
import Dinero from "dinero.js";

export default {
  computed: {
    ...mapGetters(["currentCapsule"]),

    backgroundImage() {
      return (
        'background-image: url("' +
        this.layerProduct.product.featured_image +
        '")'
      );
    },

    capsulePublished() {
      return this.currentCapsule.status == "published";
    }
  },

  props: ["layerProduct"],

  methods: {
    showRemoveProductModal() {
      this.$nextTick(() => {
        this.$modal.show("confirm-remove-product", {
          capsuleId: this.currentCapsule.id,
          layerProduct: this.layerProduct
        });
      });
    },

    showAddReferralLinkModal() {
      let payload = {
        capsuleId: this.currentCapsule.id,
        layerProduct: this.layerProduct
      };

      bus.$emit("openAddReferralLinkModal", payload);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_breakpoints.scss";

.item-container {
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  cursor: move;
}

.item-image {
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  background-color: #fff;
  width: 240px;
  height: 280px;
  border-top: 1px solid #ffffff;
  border-radius: 0.3em !important;

  &:hover {
    transition: transform 0.18s ease;
    transform: rotateZ(5deg);

    &:not(:active) &:not(.ghost) {
      border-top: 1px solid #f2f2f2;
      box-shadow: 0px 5px 5px 0px rgba(169, 169, 169, 1);
    }
  }

  &:active {
    transition: transform 0.18s ease;
    transform: rotateZ(5deg);
  }

  @include for-tablet-portrait-up {
    width: 200px;
    height: 250px;
  }

  @include for-tablet-landscape-up {
    width: 240px;
    height: 280px;
  }
}

.item-text-wrapper {
  margin: 10px auto 10px;
  font-size: 10px;
}

.item-name {
  font-size: 0.8rem;
  text-align: center;
  color: #ccc;
}

.item-price {
  text-align: center;
}
.remove-link {
  cursor: pointer;
}

.actions {
  margin-top: 10px;

  .action-link {
    text-decoration: none;
    color: $primary-blue;
  }

  .action-icon {
    padding: 10px;
    cursor: pointer;
    font-size: 1rem;
    color: $primary-blue;

    &.active {
      color: $primary-accent;
    }

    &:hover {
      background-color: rgba(158, 158, 158, 0.2);
      border-radius: 50%;
    }
    &:active {
      background-color: rgba(158, 158, 158, 0.4);
    }
  }
}

.circle-button {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  height: 25px;
  width: 25px;
  border-radius: 50%;
  border: 1px solid hsl(255, 100%, 61%);
  background-color: white;
  margin-bottom: 2em;
  color: hsl(255, 100%, 61%);
  fill: hsl(255, 100%, 61%);
}

.circle-button:hover {
  border: 1px solid white;
  background-color: hsl(255, 100%, 61%);
  -webkit-transition: all 0.4s ease-out;
  transition: all 0.4s ease-out;
  color: white;
  fill: white;
}
.circle-button:active {
  border: 1px solid white;
  background-color: hsl(255, 100%, 61%);
  -webkit-transition: all 60ms ease;
  transition: all 60ms ease;
  -webkit-transform: scale(0.97);
  transform: scale(0.97);
  color: white;
  fill: white;
}
</style>



// WEBPACK FOOTER //
// src/components/capsuleBuilder/layerGroup/LayerProduct.vue